import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';

import createReducers from './reducers';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

const store = (initialState = {}) => {
  const middlewares = [reduxThunk];

  // Log all actions in development

  if (process.env.NODE_ENV === 'development' && process.env.REDUX_LOGS) {
    // eslint-disable-line global-require
    const { logger } = require('redux-logger');

    middlewares.push(logger);
  }

  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable */

  return createStore(createReducers(), initialState, composeEnhancers(...enhancers));
};

export default store;
